<template>
  <joy-page :joyPageStatus="joyPageStatus">
    <div class="marginTopXm">
      <template v-for="listData in listData">
        <template v-if="type == '1'">
          <div class="marginBottomXm setWhite">
            <van-cell
              icon="friends"
              :border="false"
              :title="'中队长'+listData.name"
              @click="toTaskDesc(listData)"
            >
              <div
                slot="default"
                class="action"
              >
                <span v-if="listData.children">{{listData.children.length}}小队</span>
                <span v-else>暂无小队</span>
              </div>
            </van-cell>
          </div>
        </template>
        <template v-else-if="type=='2'">
          <div class="marginBottomXm setWhite">
            <!-- <van-cell
              icon="friends"
              :border="false"
              :title="'中队长'+listData.name"
              @click="toTaskDesc(listData)"
            >
              <div
                slot="default"
                class="action"
              >
                <span v-if="listData.children">{{listData.children.length}}小队</span>
                <span v-else>暂无小队</span>
              </div>
            </van-cell> -->
            <div style="padding: 0 5px;">
              <van-cell
                is-link
                class=""
                icon="manager"
                :value="itemSon.num_person+'人'"
                @click="toTaskDesc(itemSon) "
                v-for="(itemSon, index2) in listData.children"
                :name="index2"
                :key="index2"
              >
                <div
                  slot="title"
                  v-if="itemSon.name!='' && itemSon.name!=null"
                >
                  <span class="text-grey">小队长:{{itemSon.name}}</span>
                </div>
                <div
                  slot="title"
                  v-else
                >
                  <span class="text-grey">小队长:<span style="color: #bbb;">暂未分配</span></span>
                </div>
              </van-cell>
            </div>
          </div>
        </template>
        <template v-else-if="type=='3'">
          <van-cell
            is-link
            icon="manager"
            :value="listData.num_person+'人'"
            @click="toTaskDesc(listData)"
          >
            <div
              slot="title"
              v-if="listData.name!='' && listData.name!=null"
            >
              <span class="text-grey">小队长:{{listData.name}}</span>
            </div>
            <div
              slot="title"
              v-else
            >
              <span class="text-grey">小队长:<span style="color: #bbb;">暂未分配</span></span>
            </div>
          </van-cell>
        </template>

      </template>
    </div>
  </joy-page>
</template>

<script>
export default {
  props: ['camp_id', 'user_id', 'type'],
  data() {
    return {
      joyPageStatus: '',
      isLoading: false,
      listData: '',
    }
  },
  methods: {
    toTaskDesc(item) {
      if (this.type == 1) {
        // 里面有任务,孩子,异常
        this.$router.push({
          path: '/subPackages/myTask/taskDetail2',
          query: {
            camp_id: item.camp_id,
            user_id: item.user_id,
            type: item.type,
          },
        })
      } else if (item.type == 3) {
        // 里面有任务,异常
        this.$router.push({
          path: '/subPackages/myTask/taskDetail',
          query: {
            camp_id: item.id,
            user_id: item.user_id,
            type: item.type,
          },
        })
      }
    },
    loadData() {
      this.joyPageStatus = 'loading'
      try {
        this.$axios
          .get(
            'team/tree?camp_id=' + this.camp_id + '&partner_id=' + this.user_id
          )
          .then((res) => {
            this.joyPageStatus = 'success'
            if (res.data.code == 200) {
              this.listData = res.data.data
            }
          })
          .catch(function (error) {
            this.joyPageStatus = 'fail'
          })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
  created() {
    this.loadData()
  },
}
</script>

<style>
</style>
